module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "content_period"
  }, [_c('input', {
    staticClass: "btn-period",
    attrs: {
      "id": "klickbox-filter-period",
      "type": "checkbox"
    }
  }), _vm._v(" "), _c('label', {
    staticClass: "kp-button kp-button__min btn-gray",
    attrs: {
      "for": "klickbox-filter-period"
    }
  }, [_vm._v("\n    " + _vm._s(_vm.$t('report.individual.date_filter')) + "\n  ")]), _vm._v(" "), _c('div', {
    staticClass: "period"
  }, [_c('h3', {
    staticClass: "period-title"
  }, [_vm._v(_vm._s(_vm.$t('report.individual.date_range')) + ":")]), _vm._v(" "), _c('label', [_vm._v(_vm._s(_vm.$t('report.individual.from')))]), _vm._v(" "), _c('datepicker', {
    attrs: {
      "format": _vm.format,
      "language": "pt-br",
      "placeholder": "dd/mm/aaaa"
    },
    on: {
      "selected": _vm.selectedDateFrom
    }
  }), _vm._v(" "), _c('label', [_vm._v(_vm._s(_vm.$t('report.individual.to')))]), _vm._v(" "), _c('datepicker', {
    attrs: {
      "format": _vm.format,
      "language": "pt-br",
      "placeholder": "dd/mm/aaaa"
    },
    on: {
      "selected": _vm.selectedDateTo
    }
  })], 1)])
},staticRenderFns: []}


/*****************
 ** WEBPACK FOOTER
 ** ./~/vue-loader/lib/template-compiler.js?id=data-v-1b0bad30!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/report/individual/DateFilter.vue
 ** module id = 776
 ** module chunks = 1
 **/